import { render, staticRenderFns } from "./Newsbar.vue?vue&type=template&id=88ebef2e&scoped=true&"
import script from "./Newsbar.vue?vue&type=script&lang=js&"
export * from "./Newsbar.vue?vue&type=script&lang=js&"
import style0 from "./Newsbar.vue?vue&type=style&index=0&id=88ebef2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ebef2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VOverlay,VProgressCircular,VSheet})
